export default function HelpCenter() {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h1 className="mb-4">Help Center</h1>
            <p className="lead">
              Find answers, guides, and support to get the most out of AKSEMA.
            </p>
            <div className="alert alert-info mt-4">
              <p className="mb-0">
                Our full knowledge base is under construction. In the meantime, feel free to contact our support team aksemainventory@gmail.com
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }